const QUOTE_STORAGE_KEY = 'shopify_quote_list';

class QuoteManager {
  static getQuoteList() { return JSON.parse(localStorage.getItem(QUOTE_STORAGE_KEY) || '[]'); }
  
  static saveQuoteList(list) { 
    localStorage.setItem(QUOTE_STORAGE_KEY, JSON.stringify(list)); 
    this.updateHeaderBadge(); 
  }

  static initCountries() {
    // 🌍 Complete Worldwide List (~195 Countries)
    const allCountries = [
      {n:"Australia",i:"au",c:"+61"},{n:"United States",i:"us",c:"+1"},{n:"United Kingdom",i:"gb",c:"+44"},{n:"Canada",i:"ca",c:"+1"},
      {n:"Afghanistan",i:"af",c:"+93"},{n:"Albania",i:"al",c:"+355"},{n:"Algeria",i:"dz",c:"+213"},{n:"Andorra",i:"ad",c:"+376"},{n:"Angola",i:"ao",c:"+244"},{n:"Antigua and Barbuda",i:"ag",c:"+1"},{n:"Argentina",i:"ar",c:"+54"},{n:"Armenia",i:"am",c:"+374"},{n:"Austria",i:"at",c:"+43"},{n:"Azerbaijan",i:"az",c:"+994"},{n:"Bahamas",i:"bs",c:"+1"},{n:"Bahrain",i:"bh",c:"+973"},{n:"Bangladesh",i:"bd",c:"+880"},{n:"Barbados",i:"bb",c:"+1"},{n:"Belarus",i:"by",c:"+375"},{n:"Belgium",i:"be",c:"+32"},{n:"Belize",i:"bz",c:"+501"},{n:"Benin",i:"bj",c:"+229"},{n:"Bhutan",i:"bt",c:"+975"},{n:"Bolivia",i:"bo",c:"+591"},{n:"Bosnia and Herzegovina",i:"ba",c:"+387"},{n:"Botswana",i:"bw",c:"+267"},{n:"Brazil",i:"br",c:"+55"},{n:"Brunei",i:"bn",c:"+673"},{n:"Bulgaria",i:"bg",c:"+359"},{n:"Burkina Faso",i:"bf",c:"+226"},{n:"Burundi",i:"bi",c:"+257"},{n:"Cambodia",i:"kh",c:"+855"},{n:"Cameroon",i:"cm",c:"+237"},{n:"Cape Verde",i:"cv",c:"+238"},{n:"Central African Republic",i:"cf",c:"+236"},{n:"Chad",i:"td",c:"+235"},{n:"Chile",i:"cl",c:"+56"},{n:"China",i:"cn",c:"+86"},{n:"Colombia",i:"co",c:"+57"},{n:"Comoros",i:"km",c:"+269"},{n:"Costa Rica",i:"cr",c:"+506"},{n:"Croatia",i:"hr",c:"+385"},{n:"Cuba",i:"cu",c:"+53"},{n:"Cyprus",i:"cy",c:"+357"},{n:"Czech Republic",i:"cz",c:"+420"},{n:"DR Congo",i:"cd",c:"+243"},{n:"Denmark",i:"dk",c:"+45"},{n:"Djibouti",i:"dj",c:"+253"},{n:"Dominica",i:"dm",c:"+1"},{n:"Dominican Republic",i:"do",c:"+1"},{n:"Ecuador",i:"ec",c:"+593"},{n:"Egypt",i:"eg",c:"+20"},{n:"El Salvador",i:"sv",c:"+503"},{n:"Equatorial Guinea",i:"gq",c:"+240"},{n:"Eritrea",i:"er",c:"+291"},{n:"Estonia",i:"ee",c:"+372"},{n:"Eswatini",i:"sz",c:"+268"},{n:"Ethiopia",i:"et",c:"+251"},{n:"Fiji",i:"fj",c:"+679"},{n:"Finland",i:"fi",c:"+358"},{n:"France",i:"fr",c:"+33"},{n:"Gabon",i:"ga",c:"+241"},{n:"Gambia",i:"gm",c:"+220"},{n:"Georgia",i:"ge",c:"+995"},{n:"Germany",i:"de",c:"+49"},{n:"Ghana",i:"gh",c:"+233"},{n:"Greece",i:"gr",c:"+30"},{n:"Grenada",i:"gd",c:"+1"},{n:"Guatemala",i:"gt",c:"+502"},{n:"Guinea",i:"gn",c:"+224"},{n:"Guinea-Bissau",i:"gw",c:"+245"},{n:"Guyana",i:"gy",c:"+592"},{n:"Haiti",i:"ht",c:"+509"},{n:"Honduras",i:"hn",c:"+504"},{n:"Hungary",i:"hu",c:"+36"},{n:"Iceland",i:"is",c:"+354"},{n:"India",i:"in",c:"+91"},{n:"Indonesia",i:"id",c:"+62"},{n:"Iran",i:"ir",c:"+98"},{n:"Iraq",i:"iq",c:"+964"},{n:"Ireland",i:"ie",c:"+353"},{n:"Israel",i:"il",c:"+972"},{n:"Italy",i:"it",c:"+39"},{n:"Jamaica",i:"jm",c:"+1"},{n:"Japan",i:"jp",c:"+81"},{n:"Jordan",i:"jo",c:"+962"},{n:"Kazakhstan",i:"kz",c:"+7"},{n:"Kenya",i:"ke",c:"+254"},{n:"Kiribati",i:"ki",c:"+686"},{n:"Kuwait",i:"kw",c:"+965"},{n:"Kyrgyzstan",i:"kg",c:"+996"},{n:"Laos",i:"la",c:"+856"},{n:"Latvia",i:"lv",c:"+371"},{n:"Lebanon",i:"lb",c:"+961"},{n:"Lesotho",i:"ls",c:"+266"},{n:"Liberia",i:"lr",c:"+231"},{n:"Libya",i:"ly",c:"+218"},{n:"Liechtenstein",i:"li",c:"+423"},{n:"Lithuania",i:"lt",c:"+370"},{n:"Luxembourg",i:"lu",c:"+352"},{n:"Madagascar",i:"mg",c:"+261"},{n:"Malawi",i:"mw",c:"+265"},{n:"Malaysia",i:"my",c:"+60"},{n:"Maldives",i:"mv",c:"+960"},{n:"Mali",i:"ml",c:"+223"},{n:"Malta",i:"mt",c:"+356"},{n:"Mauritania",i:"mr",c:"+222"},{n:"Mauritius",i:"mu",c:"+230"},{n:"Mexico",i:"mx",c:"+52"},{n:"Micronesia",i:"fm",c:"+691"},{n:"Moldova",i:"md",c:"+373"},{n:"Monaco",i:"mc",c:"+377"},{n:"Mongolia",i:"mn",c:"+976"},{n:"Montenegro",i:"me",c:"+382"},{n:"Morocco",i:"ma",c:"+212"},{n:"Mozambique",i:"mz",c:"+258"},{n:"Myanmar",i:"mm",c:"+95"},{n:"Namibia",i:"na",c:"+264"},{n:"Nauru",i:"nr",c:"+674"},{n:"Nepal",i:"np",c:"+977"},{n:"Netherlands",i:"nl",c:"+31"},{n:"New Zealand",i:"nz",c:"+64"},{n:"Nicaragua",i:"ni",c:"+505"},{n:"Niger",i:"ne",c:"+227"},{n:"Nigeria",i:"ng",c:"+234"},{n:"North Korea",i:"kp",c:"+850"},{n:"North Macedonia",i:"mk",c:"+389"},{n:"Norway",i:"no",c:"+47"},{n:"Oman",i:"om",c:"+968"},{n:"Pakistan",i:"pk",c:"+92"},{n:"Palau",i:"pw",c:"+680"},{n:"Palestine",i:"ps",c:"+970"},{n:"Panama",i:"pa",c:"+507"},{n:"Papua New Guinea",i:"pg",c:"+675"},{n:"Paraguay",i:"py",c:"+595"},{n:"Peru",i:"pe",c:"+51"},{n:"Philippines",i:"ph",c:"+63"},{n:"Poland",i:"pl",c:"+48"},{n:"Portugal",i:"pt",c:"+351"},{n:"Qatar",i:"qa",c:"+974"},{n:"Republic of the Congo",i:"cg",c:"+242"},{n:"Romania",i:"ro",c:"+40"},{n:"Russia",i:"ru",c:"+7"},{n:"Rwanda",i:"rw",c:"+250"},{n:"Saint Kitts and Nevis",i:"kn",c:"+1"},{n:"Saint Lucia",i:"lc",c:"+1"},{n:"Saint Vincent",i:"vc",c:"+1"},{n:"Samoa",i:"ws",c:"+685"},{n:"San Marino",i:"sm",c:"+378"},{n:"Sao Tome and Principe",i:"st",c:"+239"},{n:"Saudi Arabia",i:"sa",c:"+966"},{n:"Senegal",i:"sn",c:"+221"},{n:"Serbia",i:"rs",c:"+381"},{n:"Seychelles",i:"sc",c:"+248"},{n:"Sierra Leone",i:"sl",c:"+232"},{n:"Singapore",i:"sg",c:"+65"},{n:"Slovakia",i:"sk",c:"+421"},{n:"Slovenia",i:"si",c:"+386"},{n:"Solomon Islands",i:"sb",c:"+677"},{n:"Somalia",i:"so",c:"+252"},{n:"South Africa",i:"za",c:"+27"},{n:"South Korea",i:"kr",c:"+82"},{n:"South Sudan",i:"ss",c:"+211"},{n:"Spain",i:"es",c:"+34"},{n:"Sri Lanka",i:"lk",c:"+94"},{n:"Sudan",i:"sd",c:"+249"},{n:"Suriname",i:"sr",c:"+597"},{n:"Sweden",i:"se",c:"+46"},{n:"Switzerland",i:"ch",c:"+41"},{n:"Syria",i:"sy",c:"+963"},{n:"Taiwan",i:"tw",c:"+886"},{n:"Tajikistan",i:"tj",c:"+992"},{n:"Tanzania",i:"tz",c:"+255"},{n:"Thailand",i:"th",c:"+66"},{n:"Timor-Leste",i:"tl",c:"+670"},{n:"Togo",i:"tg",c:"+228"},{n:"Tonga",i:"to",c:"+676"},{n:"Trinidad and Tobago",i:"tt",c:"+1"},{n:"Tunisia",i:"tn",c:"+216"},{n:"Turkey",i:"tr",c:"+90"},{n:"Turkmenistan",i:"tm",c:"+993"},{n:"Tuvalu",i:"tv",c:"+688"},{n:"Uganda",i:"ug",c:"+256"},{n:"Ukraine",i:"ua",c:"+380"},{n:"United Arab Emirates",i:"ae",c:"+971"},{n:"Uruguay",i:"uy",c:"+598"},{n:"Uzbekistan",i:"uz",c:"+998"},{n:"Vanuatu",i:"vu",c:"+678"},{n:"Vatican City",i:"va",c:"+379"},{n:"Venezuela",i:"ve",c:"+58"},{n:"Vietnam",i:"vn",c:"+84"},{n:"Yemen",i:"ye",c:"+967"},{n:"Zambia",i:"zm",c:"+260"},{n:"Zimbabwe",i:"zw",c:"+263"}
    ];

    const mainSelect = document.getElementById('QuoteForm-Country');
    const phoneSelect = document.getElementById('QuoteForm-PhoneCodeSelect');
    const phoneFlag = document.getElementById('phone-flag');
    const phoneCodeText = document.getElementById('phone-code-text');

    const updatePhoneVisual = (iso, code) => {
      if(iso && code) {
        phoneFlag.className = `flag-icon fi fi-${iso}`;
        phoneCodeText.textContent = code;
      }
    };

    if (mainSelect && phoneSelect) {
      allCountries.forEach(cty => {
        // Main Dropdown Options
        const opt1 = document.createElement('option');
        opt1.value = cty.n;
        opt1.textContent = cty.n;
        opt1.dataset.iso = cty.i;
        opt1.dataset.code = cty.c;
        mainSelect.appendChild(opt1);

        // Phone Selector Dropdown Options
        const opt2 = document.createElement('option');
        opt2.value = cty.c; 
        opt2.textContent = `${cty.c} (${cty.n})`;
        opt2.dataset.iso = cty.i;
        opt2.dataset.code = cty.c;
        phoneSelect.appendChild(opt2);
      });

      // EVENT 1: Main Dropdown changes -> Override Phone Selector automatically
      mainSelect.addEventListener('change', (e) => {
        const selected = e.target.options[e.target.selectedIndex];
        updatePhoneVisual(selected.dataset.iso, selected.dataset.code);
        
        for(let i=0; i < phoneSelect.options.length; i++) {
          if(phoneSelect.options[i].dataset.iso === selected.dataset.iso) {
            phoneSelect.selectedIndex = i;
            break;
          }
        }
      });

      // EVENT 2: User manually changes Phone Override Dropdown -> Update Visual locally
      phoneSelect.addEventListener('change', (e) => {
        const override = e.target.options[e.target.selectedIndex];
        updatePhoneVisual(override.dataset.iso, override.dataset.code);
      });
    }
  }

  static addItem(product) {
    const list = this.getQuoteList();
    const existingItem = list.find(item => item.id === product.id && item.variantId === product.variantId);
    if (existingItem) existingItem.quantity += product.quantity;
    else list.push(product);
    this.saveQuoteList(list);
    this.showToast(product);
  }

  static removeItem(uniqueId) {
    const list = this.getQuoteList();
    this.saveQuoteList(list.filter(item => `${item.id}-${item.variantId}` !== uniqueId));
    this.renderQuotePage();
  }

  static updateQuantity(uniqueId, newQty) {
    if (newQty < 1) return;
    const list = this.getQuoteList();
    const item = list.find(item => `${item.id}-${item.variantId}` === uniqueId);
    if (item) {
      item.quantity = newQty;
      this.saveQuoteList(list);
      this.renderQuotePage();
    }
  }

  static updateHeaderBadge() {
    const list = this.getQuoteList();
    const count = list.reduce((total, item) => total + item.quantity, 0);
    const bubbleWrapper = document.querySelector('.quote-count-bubble');
    const bubbleText = document.querySelector('.quote-count-text');
    if (bubbleWrapper && bubbleText) {
      if (count > 0) { bubbleWrapper.classList.remove('hidden'); bubbleText.textContent = count; }
      else bubbleWrapper.classList.add('hidden');
    }
  }

  // ✨ Pop-up Notification with correct Price and formatting
  static showToast(product) {
    let toast = document.getElementById('quote-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'quote-toast';
      toast.className = 'quote-toast';
      document.body.appendChild(toast);
    }
    
    const displayPrice = product.price && product.price !== 'undefined' ? product.price : '$0.00';

    toast.innerHTML = `
      <div class="quote-toast-inner">
        <div class="quote-toast-header">
          <button class="quote-toast-close">&times;</button>
          <img src="${product.image}" alt="${product.title}" class="quote-toast-image" />
          <div class="quote-toast-details">
            <span class="quote-toast-title">${product.title}</span>
            <span class="quote-toast-price">${product.quantity} x ${displayPrice}</span>
          </div>
        </div>
        <hr class="quote-toast-divider">
        <a href="/pages/quote-request" class="quote-toast-btn">VIEW LIST</a>
      </div>
    `;
    
    toast.classList.add('active');
    
    toast.querySelector('.quote-toast-close').addEventListener('click', () => {
        toast.classList.remove('active');
    });
    
    if (window.quoteToastTimeout) clearTimeout(window.quoteToastTimeout);
    window.quoteToastTimeout = setTimeout(() => toast.classList.remove('active'), 5000);
  }

  static renderQuotePage() {
    const renderTarget = document.getElementById('quote-list-render-target');
    const formContainer = document.querySelector('.quote-form-container');
    const isSuccess = document.querySelector('.form-status.form__message') !== null;

    if (!renderTarget) return;
    const list = this.getQuoteList();
    
    if (list.length === 0) {
      // BRAND NEW STYLED EMPTY STATE WITH BUTTON
      renderTarget.innerHTML = `
        <div class="quote-empty-state" style="margin: 4rem 0; text-align: center;">
          <p style="font-size: 1.6rem; color: #666; margin-bottom: 2rem; font-family: inherit;">
            Your list is empty, add products to the list to send a request
          </p>
          <a href="/" class="empty-return-btn" style="display: inline-block; background-color: #1a1a1a; color: #ffffff; padding: 12px 32px; border-radius: 999px; text-decoration: none; font-weight: 500; font-size: 1.5rem; transition: opacity 0.3s ease, background-color 0.3s ease;" onmouseover="this.style.backgroundColor='#eb4639'" onmouseout="this.style.backgroundColor='#1a1a1a'">
            Return to Home
          </a>
        </div>
      `;
      
      this.updateHiddenFormInput();
      
      if (formContainer && !isSuccess) {
        formContainer.style.display = 'none';
      }
      return;
    }

    if (formContainer) {
      formContainer.style.display = 'block';
    }

    let html = `<div class="quote-table-wrapper"><table class="quote-table"><thead><tr><th class="th-product">PRODUCT</th><th class="th-quantity">QUANTITY</th></tr></thead><tbody>`;
    list.forEach(item => {
      const uniqueId = `${item.id}-${item.variantId}`;
      html += `<tr class="quote-item-row" data-id="${uniqueId}">
        <td class="quote-item-details">
          <button class="quote-remove-btn" type="button" data-id="${uniqueId}">&times;</button>
          <div class="img-btn-wrapper">
          <div class="quote-item-image-wrapper"><img src="${item.image}" alt="${item.title}" /></div>
          <a href="${item.url}" class="quote-item-title">${item.title}</a>
          </div>
        </td>
        <td class="quote-item-quantity"><div class="quantity-wrapper"><div class="quantity">
          <button class="quantity__button no-js-hidden" name="minus" type="button" data-id="${uniqueId}">&minus;</button>
          <input class="quantity__input" type="number" name="updates[]" value="${item.quantity}" min="1" data-id="${uniqueId}">
          <button class="quantity__button no-js-hidden" name="plus" type="button" data-id="${uniqueId}">&plus;</button>
        </div></div></td></tr>`;
    });
    html += `</tbody></table></div><div class="quote-actions"></div>`;
    
    renderTarget.innerHTML = html;
    this.updateHiddenFormInput();

    renderTarget.querySelectorAll('.quote-remove-btn').forEach(btn => btn.addEventListener('click', (e) => this.removeItem(e.currentTarget.dataset.id)));
    renderTarget.querySelectorAll('button[name="minus"]').forEach(btn => btn.addEventListener('click', (e) => {
      const i = e.currentTarget.nextElementSibling; if(parseInt(i.value)>1) i.value = parseInt(i.value)-1;
    }));
    renderTarget.querySelectorAll('button[name="plus"]').forEach(btn => btn.addEventListener('click', (e) => {
      const i = e.currentTarget.previousElementSibling; i.value = parseInt(i.value)+1;
    }));
    renderTarget.querySelector('.quote-update-btn').addEventListener('click', () => {
      renderTarget.querySelectorAll('.quantity__input').forEach(input => this.updateQuantity(input.dataset.id, parseInt(input.value)));
    });
  }


  static updateHiddenFormInput() {
    const input = document.getElementById('contact_quote_details');
    if (!input) return;
    const list = this.getQuoteList();
    if (list.length === 0) { input.value = "No items in quote."; return; }
    
    let details = "QUOTE DETAILS:\n\n";
    list.forEach((item, index) => { details += `${index + 1}. ${item.title}\n   Quantity: ${item.quantity}\n   Link: ${window.location.origin}${item.url}\n\n`; });
    input.value = details;
  }

  static init() {
    this.updateHeaderBadge();
    this.initCountries();
    
    document.body.addEventListener('click', (e) => {
      if (e.target.closest('.quote-add-btn')) {
        const btn = e.target.closest('.quote-add-btn');
        let quantity = 1;
        const section = btn.closest('product-info') || document;
        const qtyInput = section.querySelector('.quantity__input');
        if (qtyInput) quantity = parseInt(qtyInput.value) || 1;
        this.addItem({
          id: btn.dataset.id, variantId: btn.dataset.variantId, title: btn.dataset.title,
          image: btn.dataset.image, price: btn.dataset.price, url: btn.dataset.url, quantity: quantity
        });
      }
    });

    if (document.getElementById('quote-list-render-target')) this.renderQuotePage();
  }
}

document.addEventListener('DOMContentLoaded', () => QuoteManager.init());
